import React, { useEffect, useState } from 'react';

const NavBar = ({ user }) => {
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        if (user) setUserRole(user.role);
    }, [user]);

    return(
        <nav>
            <ul>
                <li><a href="/index.html">Home</a></li>
                {userRole !== 'judge' && <li><a href="/aircraft.html">Aircraft</a></li>}
                {userRole !== 'judge' && <li><a href="/scores.html">Scoring</a></li>}
                {userRole === 'admin' && <li><a href="/volunteers.html">Volunteers</a></li>}
                <li><a href="/judging.html">Judging</a></li>
            </ul>
        </nav>
    );
}

export default NavBar;